Ext.define('SA.view.Spinner', {
    alias: 'widget.spinner',
    extend: 'Ext.Component',

    baseCls: 'sa-spinner',

    initComponent() {
        this.initSize();
        this.initHtml();

        this.callParent();
    },

    initHtml() {
        var cmpId = this.getId();

        this.html = [
            '<svg xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd" viewBox="0 0 160 240">',
                '<defs>',
                    `<linearGradient id="${cmpId}-gradient-1" y2="100%">`,
                        '<stop offset="0%" stop-color="#3DB1A7"/>',
                        '<stop offset="100%" stop-color="#26AC9D"/>',
                    '</linearGradient>',
                    `<linearGradient id="${cmpId}-gradient-2" x1="100%" x2="0%" y2="100%">`,
                        '<stop offset="0%" stop-color="#0089BA"/>',
                        '<stop offset="100%" stop-color="#1094C4"/>',
                    '</linearGradient>',
                    `<linearGradient id="${cmpId}-gradient-3" y2="100%">`,
                        '<stop offset="0%" stop-color="#1B619B"/>',
                        '<stop offset="100%" stop-color="#1878BC"/>',
                    '</linearGradient>',
                    `<linearGradient id="${cmpId}-gradient-4" y2="100%">`,
                        '<stop offset="0%" stop-color="#E35525"/>',
                        '<stop offset="100%" stop-color="#E75F24"/>',
                    '</linearGradient>',
                    `<linearGradient id="${cmpId}-gradient-5" x1="100%" x2="0%" y2="100%">`,
                        '<stop offset="0%" stop-color="#E06D26"/>',
                        '<stop offset="100%" stop-color="#EA8624"/>',
                    '</linearGradient>',
                    `<linearGradient id="${cmpId}-gradient-6" y2="100%">`,
                        '<stop offset="0%" stop-color="#EF9620"/>',
                        '<stop offset="100%" stop-color="#F5AB1C"/>',
                    '</linearGradient>',
                    `<linearGradient id="${cmpId}-gradient-7" x1="100%" x2="0%" y2="100%">`,
                        '<stop offset="0%" stop-color="#BC5611"/>',
                        '<stop offset="100%" stop-color="#E68024"/>',
                    '</linearGradient>',
                    `<linearGradient id="${cmpId}-gradient-8" y2="100%">`,
                        '<stop offset="0%" stop-color="#124B7F"/>',
                        '<stop offset="100%" stop-color="#1A6CB2"/>',
                    '</linearGradient>',
                '</defs>',
                '<path class="sa-spinner-line-1" fill="none" stroke="#2aad9f" d="M79.3 54.7l46.2 37.9 23.7-20.7-69.8-57.5"/>',
                '<path class="sa-spinner-line-2" fill="none" stroke="#008ebe" d="M10.5 71.9v40.3l68.7-57V15L10.5 72z"/>',
                '<path class="sa-spinner-line-3" fill="none" stroke="#1977bb" d="M10.3 113l69.9 57.6 23.7-20.8-69.3-57.1"/>',
                '<path class="sa-spinner-line-4" fill="none" stroke="#e65925" d="M80.6 187.4l-46-37.8-23.8 20.7 69.8 57.3"/>',
                '<path class="sa-spinner-line-5" fill="none" stroke="#e88024" d="M80.9 186.9V227l68.6-56.8-24-20.4-44.6 37z"/>',
                '<path class="sa-spinner-line-6" fill="none" stroke="#f3a11e" d="M149.7 170.2v-41L79.8 71.6 56.1 92.3l69 57.1"/>',
                `<path class="sa-spinner-shape-1" fill="url(#${cmpId}-gradient-1)" d="M125.5 93.2L150 72l-70.3-58v41.6l45.8 37.7z"/>`,
                `<path class="sa-spinner-shape-2" fill="url(#${cmpId}-gradient-2)" d="M79.7 55.5V14L10 71.7v41.6l69.7-57.8z"/>`,
                `<path class="sa-spinner-shape-3" fill="url(#${cmpId}-gradient-3)" d="M35.1 92.4l-25 20.9 70 58 24.6-21.5L35 92.4z"/>`,
                `<path class="sa-spinner-shape-4" fill="url(#${cmpId}-gradient-4)" d="M34.5 149L10 170.2l70.4 57.9v-41.5l-45.9-37.8z"/>`,
                `<path class="sa-spinner-shape-5" fill="url(#${cmpId}-gradient-5)" d="M124.9 149.7l25.1 20.8-69.6 57.7v-41.5l44.5-37z"/>`,
                `<path class="sa-spinner-shape-6" fill="url(#${cmpId}-gradient-6)" d="M79.8 71L55.3 92.3l94.7 78.2V129l-70.2-58z"/>`,
                `<path class="sa-spinner-shape-7" fill="url(#${cmpId}-gradient-7)" d="M127 165.4a28.2 28.2 0 0 0-7-11.6l4.9-4 25.1 20.7-22.9 19a43 43 0 0 0 0-24h-.1z"/>`,
                `<path class="sa-spinner-shape-8" fill="url(#${cmpId}-gradient-8)" d="M35.1 92.4l-25 20.9L32.7 132a43 43 0 0 1 .1-24c1.6-4.6 4-8.5 7.2-11.6l-5-4z"/>`,
            '</svg>'
        ];
    },

    initSize() {
        var heightWidthRatio = 3 / 2;

        if (this.maxLength) {
            this.height = this.maxLength;
            this.width = this.height / heightWidthRatio;

            return;
        }

        this.height = this.width * heightWidthRatio;
    }
});